module.exports = __webpack_public_path__ + "media/customizations/default/chat-bubble-072f81b7e970726c9dfafddecf9159ab.png";